<template>
  <div>
      <div class="report_tc">
        <img :src="img_url +material.pc_jb_ts">
      </div>
      <div class="violation_tc">
        <img :src="img_url +material.pc_wg_ts">
      </div>
      <div class="vote_tc">
        <img :src="img_url +material.pc_tp_ts">
      </div>
  </div>
    
  </template>
  
  <script>
  import { mapState } from "vuex";
    export default {
        name:'Age',
        data() {
          return {
          }
        },
        computed:{
          ...mapState([
            'getClient',
            'material'
          ])
        },
    }
  </script>
  
  <style scoped>
    /* 弹窗 */
    .report_tc{
      display: none;
    }
    .violation_tc{
      display: none;
    }
    .vote_tc{
      display: none;
    }
  </style>